<script setup lang="ts">
import { ORDER_STATUS } from "core/interfaces";

import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useModalStore } from "~/stores/modal";
import { useOrdersStore } from "~/stores/orders";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { ordersConfirmClose } = useModalStore();
const ordersStore = useOrdersStore();

const submitOrderClose = async () => {
	await ordersStore.patchById(ordersConfirmClose.order.id, {
		status: ORDER_STATUS.CLOSED
	});

	ordersConfirmClose.closeModal();

	if (route.name === "orders") {
		ordersStore.getAll({}, ordersStore.recentGetAllQuery);
	} else {
		ordersStore.currentOrder = await ordersStore.getById(ordersConfirmClose.order.id);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.ORDERS.CONFIRM_CLOSE.alert.title"),
		description: t("COMPONENTS.ORDERS.CONFIRM_CLOSE.alert.description", { nonce: ordersConfirmClose.order.id }),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.ORDERS.CONFIRM_CLOSE.title')"
		:description="$t('COMPONENTS.ORDERS.CONFIRM_CLOSE.description', {nonce: ordersConfirmClose.order.id})"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesClose')"
		submit-button-color="violet"
		@close="ordersConfirmClose.closeModal"
		@submit="submitOrderClose"
	/>
</template>
